import React from 'react';
export default {
  'cart': {
    'change-currency': 'Para birimini değiştir',
    'and-then': 'Daha sonrasında',
    'plus-tax': ' + vergi',
    'for': 'Kimin için',
    'edit': {
      'label': 'Düzenle',
      'submit': 'Uygula'
    },
    'empty': 'Siparişinize henüz bir şey eklemediniz.',
    'free': 'ücretsiz',
    'promo-code': {
      'add': 'Hediye kartı veya indirim kodu ekle',
      'error': {
        'invalid-for-subscription': 'Kupon kodu bu sipariş için geçerli değil.'
      },
      'label': 'Hediye kartı veya indirim kodu',
      'submit': 'Uygula'
    },
    'subtotal-line': {
      'tax-label': 'Tahmini vergi ücreti',
      'subtotal': 'Ara toplam',
      'tax': 'Vergi',
      'gift-card': 'hediye kartı'
    },
    'starting-price': 'Başlangıç fiyatı',
    'title': 'Sipariş Özeti',
    'setup-fee': 'kurulum ücreti',
    'free-trial': 'ücretsiz deneme',
    'total-line': {
      'label': 'Toplam'
    },
    'order-total-line': {
      'label': 'Toplam sipariş'
    }
  },
  'address': {
    'country': 'Ülke',
    'address2': 'Apartman, kapı numarası vs.',
    'tax-identifier': 'Vergi tanımlayıcı',
    'tax-identifier-type': 'Vergi tanımlayıcı türü',
    'first-name': 'İsim',
    'last-name': 'Soyadı',
    'company-name': 'Firma Adı',
    'address1': 'Sokak Adresi',
    'city': 'Şehir',
    'state': 'Il',
    'postal-code': 'Posta Kodu',
    'phone-number': 'Telefon numarası',
    'vat-number': 'KDV Numarası/Vergi Kimliği'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Kart bilgileri',
      'expiry': 'AA/YY',
      'name': 'Kredi Kartı',
      'number': 'Kredi Kartı Numarası',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Banka Hesabı',
      'routing-number': 'Bankanizin Routing Numarasi',
      'account-number': 'Hesap Numarası',
      'account-number-confirmation': 'Hesap Numaranizi Onaylayin',
      'account-type': {
        'label': 'Hesap Tipi',
        'checking': 'Vadesiz Mevduat ',
        'savings': 'Vadeli Mevduat'
      },
      'name-on-account': 'Hesap Sahibinin Ismi'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort Kodu'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB Kodu'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Fatura adresi',
  'billing-address-same-as-shipping': 'Teslimat adresiyle aynı',
  'submit': 'Şimdi öde',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} seçildi</>,
  'express-checkout': 'Ekspres Ödeme',
  'change-payment-method': 'Ödeme yöntemini değiştir',
  'day': 'gün',
  'days': 'gün',
  'week': 'hafta',
  'weeks': 'hafta',
  'month': 'ay',
  'months': 'ay',
  'year': 'yıl',
  'years': 'yıl',
  'confirmation': {
    'title': 'Siparişiniz için teşekkür ederiz',
    'order-num': ({ number }: { number: number }) => <>Sipariş #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Tamamlandı {date}</>,
    'email-notice': 'Siparişiniz için bir e-posta doğrulaması alacaksınız.',
    'payment': 'Ödeme',
    'return-to': ({ name }: { name: string }) => <>{name} dönün </>,
    'credit-applied': 'Kredi Uygulandı'
  },
  'back': 'Geri',
  'contact-info': 'İletişim Bilgileri',
  'email-address': 'E-posta',
  'payment-info': 'Ödeme Bilgileri',
  'shipping-address': 'teslimat adresi',
  'legal': {
    'accept': 'Kabul ediyorum',
    'privacy-policy': 'Gizlilik Politikası',
    'terms-of-service': 'Hizmet Koşulları'
  },
  'recurring': {
    'consent': `Abonelik geçerli faturalandırma dönemi sona ermeden iptal edilmediği sürece,
                yukarıda gösterilen ücretleri faturalandırma sıklığıyla birlikte takrar eden bir şekilde ödemeyi kabul ediyorum.`,
    'cancel': 'Aboneliğnizi iptal etmek için Hesap Yönetimi sayfanızı ziyaret edin.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'gün' : 'gün',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'hafta' : 'hafta',
    'months': ({ count }: { count: number }) => count === 1 ? 'ay' : 'ay',
    'years': ({ count }: { count: number }) => count === 1 ? 'yıl' : 'yıl'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>{addOnName} için {amount}/birim ücretlendirileceksiniz</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>{addOnName} için {units} {unitsLabel} için {amount} ücretlendirileceksiniz</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>{startDate} tarihinden itibaren {amount}/{intervalLengthLabel}{taxable ? ' + vergi' : ''} faturalandırılacaksınız</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>{startDate} tarihinden itibaren {amount}/{intervalLengthLabel}{taxable ? ' + vergi' : ''} faturalandırılacaksınız, ayrıca {setupFee} tek seferlik ücret</>,
      'cancellation.reminder': ({ days }: { days: number }) => `Faturalandırma başlamadan ${days} gün önce e-posta hatırlatıcısı alacaksınız.`,
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>Ücretsiz {trialLength} {trialInterval} deneme süreniz bugün başlıyor.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Ücretlendirilmekten kaçınmak için {trialEndsAt} tarihinden önce iptal etmelisiniz.</>,
      'email.reminder': ({ days }: { days: number }) => <>Faturalandırma başlamadan {days} gün önce e-posta hatırlatıcısı alacaksınız</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Aboneliğiniz {billingEndsAt} tarihinde sona erecek ve otomatik olarak yenilenmeyecek.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>{afterChargeTime} sonrasında {newChargeAmount} + vergi ücretlendirileceksiniz</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Aboneliğiniz her {totalCyclesLengthLabel} otomatik olarak yenilenecek ve iptal edene kadar devam edecek.</>,
      'title': 'Abonelik Detayları',
    },
    'agreement.button': 'Kabul Et ve Devam Et',
    'agreement.text': '"Kabul Et ve Devam Et" düğmesini tıklayarak, bu abonelik koşullarını anladığınızı ve kabul ettiğinizi onaylarsınız. Ödeme işlemini tamamlayana kadar herhangi bir ücret uygulanmayacaktır.',
    'changeOrCancel': 'Aboneliğinizi değiştirmek veya iptal etmek için ',
    'access-account': 'hesabınıza erişin',
    'contact-support': 'destek ile iletişime geçin',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' ve ',
      'lastWordConnector': ' ve '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Abonelik faturalandırması {recurly} tarafından yapılmaktadır</>,
  'errors': {},
  'subscribe': 'Abone olun'
};
